import { ReservationStatus } from 'chaika-enums';
import { Optional } from 'chaika-common-types';

import { ReservationDataWithAssociatedServices } from 'chaika-frontend-types/frontend-cms';
import { collectReservationExecutorIds } from '@patient/services/ehr/reservationExecutorAndOrganization';
import { SimpleList } from '@store/models/SimpleList';
import { DateHelper } from '@utils/DateHelper';
import orderBy from 'lodash/orderBy';

export interface PatientReservationFilterParams {
    author?: string[];
    executor?: string[];
    status?: ReservationStatusRus[];
    startTime?: Date;
    serviceIds?: string[];
}

export enum ReservationStatusRus {
    Active = 'Активно',
    Expired = 'Просрочено',
    Cancelled = 'Отменено',
    VisitOccurred = 'Исполнено',
}

export class PatientReservationList extends SimpleList<
    ReservationDataWithAssociatedServices,
    PatientReservationFilterParams
> {
    protected filterValue(
        value: ReservationDataWithAssociatedServices,
        { author, status, serviceIds, executor, startTime, ...props }: PatientReservationFilterParams,
    ): boolean {
        return (
            this.filterFieldValueByArray(value, author, 'authorId') &&
            this.filterByStatus(status, value) &&
            this.filterByExecutor(executor, value) &&
            this.filterArrayFieldValueByArray(value, serviceIds, 'associatedServiceIds') &&
            this.filterFilterValueBeforeFieldValue(value, startTime, 'startTime')
        );
    }

    protected getOrderedValues(
        params: ReservationDataWithAssociatedServices[],
    ): ReservationDataWithAssociatedServices[] {
        return orderBy(params, ['startTime'], ['desc']);
    }

    private filterByExecutor(executor: Optional<string[]>, value: ReservationDataWithAssociatedServices): boolean {
        return executor ? collectReservationExecutorIds(value).some(executorId => executor.includes(executorId)) : true;
    }

    private filterByStatus(
        status: Optional<ReservationStatusRus[]>,
        value: ReservationDataWithAssociatedServices,
    ): boolean {
        let valueStatus: ReservationStatusRus;

        switch (value.status) {
            case ReservationStatus.Reserved: {
                if (DateHelper.isAfter(Date.now(), value.startTime)) {
                    valueStatus = ReservationStatusRus.Expired;
                } else {
                    valueStatus = ReservationStatusRus.Active;
                }
                break;
            }
            case ReservationStatus.Cancelled: {
                valueStatus = ReservationStatusRus.Cancelled;
                break;
            }
            case ReservationStatus.VisitOccurred: {
                valueStatus = ReservationStatusRus.VisitOccurred;
                break;
            }
        }

        return status ? status.includes(valueStatus) : true;
    }
}
